export default class UrlProps {
  constructor() {
    this.dom = {
      $script: document.getElementById('ometriaJson') ? document.getElementById('ometriaJson').innerHTML : null,
    };
    this.state = {
      $url: false,
      $utm: false,
      $data: false,
      $params: false,
      $properties: false,
      $store: location.host,
    };
    this.mount();
  }
  get url() {
    return new URL(location.href);
  }
  get utm() {
    const { $url } = this.state;
    if (!$url) return false;

    const { searchParams: params } = $url;
    const utm = new Map();

    params.forEach((value, key) => {
      if (key.includes('utm')) utm.set(key, value);
    });

    return utm;
  }
  get params() {
    const { $url } = this.state;
    if (!$url) return false;

    const { search: params } = $url;

    return params;
  }
  get data() {
    const { $script } = this.dom;
    return JSON.parse($script);
  }
  get properties() {
    const { state } = this;
    if (!state.$url) return {};

    let data;
    const hasParams = state.$params !== '';

    if (hasParams) {
      data = {
        ...Object.fromEntries(state.$utm),
        query_params: state.$params,
      };
    } else {
      data = { ...Object.fromEntries(state.$utm) };
    }

    return data;
  }
  setState() {
    const { state } = this;
    const sessionData = JSON.parse(sessionStorage.getItem('_bl__url_props'));
    // If there's an existing UTM data then set that to the state
    // This will prevent the state from reseting on every single on load.
    if (sessionData) return (state.$properties = sessionData);

    state.$url = this.url;
    state.$utm = this.utm;
    state.$data = this.data;
    state.$params = this.params;
    state.$properties = this.properties;
  }
  setSessionData() {
    const { $properties } = this.state;
    if (Object.entries($properties).length === 0) return;

    return sessionStorage.setItem('_bl__url_props', JSON.stringify($properties));
  }
  getUrlData() {
    const { $properties } = this.state;
    if ($properties) return $properties;
  }
  mount() {
    this.setState();
    this.setSessionData();
    window.Brooklinen = window.Brooklinen || {};
    window.Brooklinen.getUrlData = this.getUrlData.bind(this);
  }
}
